<template>
  <a-modal
    :title="language['depart']"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: confirmLoading} }"
    :cancelButtonProps="{props: {disabled: confirmLoading}}"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="language['common.importButton']"
    :cancelText="language['common.closeButton']">
      <a-row :gutter="10">
        <a-col :md="10" :sm="24">
          <a-tree
            :treeData="departTree"
            />
        </a-col>
      </a-row>
  </a-modal>
</template>

<script>
  import {queryDepartTreeList, searchByKeywords, deleteByDepartId} from '@/api/api'
  import {httpAction, deleteAction, getAction,postAction} from '@/api/manage'
    export default {
      name: "StandardDepartModel",
      data() {
        return {
          departTree: [],
          loading: false,
          visible: false,
          disableSubmit: false,
          confirmLoading:false,
          title:"平台部门",
        }
      },
      computed:{
        language() {
          return this.$store.getters.language
        },
      },
      methods:{
        /*handleOk(){
          this.$emit('ok');
          this.close()
        },*/
        handleOk(){
          this.confirmLoading = true;
          getAction("/sys/sysDepart/addStandardDepart",{'applicationCode':this.$store.getters.applicationCode}).then((res) => {
            if (res.success) {
              this.confirmLoading = false;
              this.$emit('ok');
              this.close()
              // this.artificialPersonList = res.result;
            }else{
              this.$message.warning(res.message);
            }
          })
        },
        close () {
          if(this.confirmLoading){
            return;
          }
          this.$emit('close');
          this.visible = false;
        },
        handleCancel() {
          this.close()
        },
        loadTree() {
          this.visible = true;
          var that = this
          that.departTree = []
          queryDepartTreeList({"applicationCode":"platform"}).then((res) => {
            if (res.success) {
              //部门全选后，再添加部门，选中数量增多
              this.allTreeKeys = [];
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
                // that.setThisExpandedKeys(temp)
                // that.getAllKeys(temp);
                // console.log(temp.id)
              }
              this.loading = false
            }
          })
        },

      }
    }
</script>

<style scoped>

</style>